module.exports = __webpack_public_path__ + "img/20200529_093518.e852f974.jpg";